import { MODAL_POSITION_TYPE } from './modal-positiong.type';
import { Theme } from 'baseui/theme';
import { StyleObject } from 'styletron-react';
import { MOBILE_NAVBAR_HEIGHT } from '../Navbar/MobileNavBar.styled';

export const MODAL_DEFAULT_SIZE = '548px';
export const MODAL_FULL = '100%';

export const acOverrides = (
  modalkind: MODAL_POSITION_TYPE,
  kind: 'primary' | 'secondary' | 'success' | 'warning' | 'danger',
  isMobile: boolean
): any => {
  const isFullscreen = modalkind === 'full_screen';
  const containerVerticalFlexAlign = isFullscreen ? 'stretch' : 'center';
  const desktopDialogWidth = isFullscreen ? MODAL_FULL : MODAL_DEFAULT_SIZE;

  return {
    Root: {
      style: () => ({
        zIndex: 51,
        padding: isMobile ? '5px' : '0px',
        height: isMobile
          ? `calc(100% - ${Number(MOBILE_NAVBAR_HEIGHT)}px)`
          : '100%',
      }),
    },
    Backdrop: {
      style: (): any => {
        return {
          display: 'none',
        };
      },
    },
    DialogContainer: {
      style: ({ $theme }: { $theme: Theme }): StyleObject => {
        const desktopMediaQuery = $theme.mediaQuery.small;
        return {
          alignItems: 'stretch',
          justifyContent: 'center',
          backgroundColor: 'transparent',
          backdropFilter: 'blur(30px)',
          [desktopMediaQuery]: {
            alignItems: containerVerticalFlexAlign,
          },
        };
      },
    },
    Dialog: {
      style: ({ $theme }: { $theme: Theme }): StyleObject => {
        const desktopMediaQuery = $theme.mediaQuery.small;

        const defaultConfig = {
          width: MODAL_FULL,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
          borderColor: $theme.colors.primary700,
          background: 'transparent',
          borderStyle: $theme.borders.border200.borderStyle,
          borderWidth: $theme.borders.border200.borderWidth,
          borderTopLeftRadius: $theme.borders.radius300,
          borderTopRightRadius: $theme.borders.radius300,
          borderBottomRightRadius: $theme.borders.radius300,
          borderBottomLeftRadius: $theme.borders.radius300,
          [desktopMediaQuery]: {
            width: desktopDialogWidth,
            marginTop: $theme.sizing.scale1000,
            marginRight: $theme.sizing.scale1000,
            marginBottom: $theme.sizing.scale1000,
            marginLeft: $theme.sizing.scale1000,
          },
        };

        switch (kind) {
          case 'primary':
            return defaultConfig as StyleObject;
          default:
            return defaultConfig as StyleObject;
        }
      },
    },
    Close: {
      props: ({ children, ...rest }: any) => ({
        children: () => <div>Close</div>,
        ...rest,
      }),
    },
  };
};
